import angular, { bootstrap } from 'angular';

import Ricola from 'ricola3';
import ngResource from 'angular-resource';
import uiRouter from 'angular-ui-router';

import App from './app/';
import SearchInterface from './search-interface/';

const app = angular.module('searchEngineFrontend', [
  Ricola,
  ngResource,
  uiRouter,
  App.name,
  SearchInterface.name
]);

angular.element(document).ready(() => {
  bootstrap(document.documentElement, [app.name], {
    strictDi: !("mock" in angular)
  });
}); 

export default app.name;



// WEBPACK FOOTER //
// ./src/index.js